module.exports = __webpack_public_path__ + "img/sm.bc88a04e.svg";